<template>
  <div>
    <div style="display: flex;flex-direction: row;width: 100%; position: relative;">
      <!-- 回显下单最后编辑的图片 -->
      <div class="design-img">
        <img :src="orderDetail.servOrderRpd.designActiveImg">
      </div>
      <div class="design-info">
        <!-- 基本信息 -->
        <div class="order-input-wrap">
          <base-tag label="基本信息"></base-tag>
          <!-- 联系人姓名 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>下单名称：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.demContact }}
            </div>  
          </div>
          <!-- 联系方式 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>联系方式：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.demPhone }}
            </div>
          </div>
          <!-- 患者姓名 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>患者姓名：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.demPatient }}
            </div>
          </div>
          <!-- 患者性别 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>患者性别：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.demSex == '00' ? '男' : '女' }}
            </div>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="order-input-wrap">
          <base-tag label="设计费详情"></base-tag>
          <!-- 数量 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>数量：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.orderCount }}
            </div>
          </div>
          <!-- 单价 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>单价：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.orderPrice) }} 元
            </div>
          </div>
          <!-- 钢牙数量 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.steelCount">
            <div class="input-label">
              <span>钢牙数量：</span>
            </div>
            <div class="input-value">
              {{orderDetail.servOrderRpd.steelCount}}
            </div>
          </div>
          <!-- 钢牙单价 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.steelCount">
            <div class="input-label">
              <span>钢牙单价：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.servOrderRpd.steelPrice) }} 元
            </div>
          </div>
          <!-- 充胶牙数量 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.glueCount">
            <div class="input-label">
              <span>充胶牙数量：</span>
            </div>
            <div class="input-value">
              {{orderDetail.servOrderRpd.glueCount}}
            </div>
          </div>
          <!-- 充胶牙单价 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.glueCount">
            <div class="input-label">
              <span>充胶牙单价：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.servOrderRpd.gluePrice) }} 元
            </div>
          </div>
          <!-- 精密附件数量 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.enclosureCount">
            <div class="input-label">
              <span>精密附件数量：</span>
            </div>
            <div class="input-value">
              {{orderDetail.servOrderRpd.enclosureCount}}
            </div>
          </div>
          <!-- 精密附件单价 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.enclosureCount">
            <div class="input-label">
              <span>精密附件单价：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.servOrderRpd.enclosurePrice) }} 元
            </div>
          </div>
          <!-- 加急费 -->
          <div class="input-form-wrap-row" v-if="orderDetail.orderRushFee != 0">
            <div class="input-label">
              <span>加急费：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.orderRushFee) }}
            </div>
          </div>
          <!-- 模型编辑费 -->
          <div class="input-form-wrap-row" v-if="orderDetail.isEditScanModel == '1'">
            <div class="input-label">
              <span>口扫模型编辑：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(common.serv.get(orderDetail.servCataId).editScanModelBprice) }} 元
            </div>
          </div>
          <!-- 总价 -->
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>总价：</span>
            </div>
            <div class="input-value">
              {{ parseMoney(orderDetail.orderAmount) }} 元
            </div>
          </div>
        </div>
        <div class="order-input-wrap" v-if="isDesign">
          <base-tag label="设计需求"></base-tag>
          <!-- 下单类型 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.designTray">
            <div class="input-label">
              <span>下单类型：</span>
            </div>
            <div class="input-value">
              {{ showStr(orderDetail.servOrderRpd.designTray) }}
            </div>
          </div>
          <!-- 精密附件 -->
          <div class="input-form-wrap-row" v-if="orderDetail.servOrderRpd.enclosure">
            <div class="input-label">
              <span>精密附件：</span>
            </div>
            <div class="input-value">
              {{ orderDetail.servOrderRpd.enclosure }}
            </div>
          </div>
        </div>
        <!-- 备注信息 -->
        <div class="order-input-wrap">
          <base-tag label="备注信息"></base-tag>
          <div class="input-textarea">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }" disabled readonly
              v-model="orderDetail.orderRemark" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTag from '/components/BaseTag';
import DictTag from '/components/DictTag';
import DTooth from '/components/DTooth';
import {
  mapState
} from 'vuex'
import { parseMoney } from '../../../utils/utils';
export default {
  data() {
    return {
      colorAdhesiveGap: '',   //黏着剂间隙
      colorAdhesiveExtraGap: '', //额外黏着剂间隙
      colorMinThick: '',         //最小厚度
      colorWallHeight: '',       //壁高度
      colorEdgeLineDistance: '',   //到边缘线的距离
      colorSmoothDistance: '',   //平滑距离
      colorBurRadius: '',       //车针半径
      colorBurGapOffset: '',     //车针补偿间距
      colorEdgeLineOffset: '',   //边缘线补偿
      colorStretchOffset: '',    //延伸补偿
      colorAngleOffset: '',      //补偿角度
      colorTongueSideOffset: '', //舌侧边
      colorCircleSideOffset: '', //360度边
      colorPlateThickness: '',//导板厚度
      colorTeethModelDeviation: '',//牙齿/模型偏移
      colorRecessedRetentionAmount: '',//倒凹保留量
      colorGuideRingCompensatio: '',//从导环的补偿
      colorPolymerization: '',//聚合度
      colorBaseHeight: '',//基台高度
      colorShoulderWidth: '',//肩台宽度
      colorShoulderAngle: '',//肩台角度
      colorGingiva: '',//牙龈位置
      colorSupragingival: '',//龈上参数
      colorocclusalClearance: '',//咬合间隙
      colorAdjacencyGap: '',//邻接间隙

      CAMName: '', //CAM名称
      impSystem: '',/** 植体系统 */
      impModel: '', /** 植体型号 */
      idProperty: 'implId',
      abutment: false,//基台
      fund: 0,
      basePrice: 0,
      quantity: 0,
      extraUnitPrice: 0,
      designCost: 0,
    }
  },
  props: {
    orderDetail: {
      type: Object,
      default: null
    },
  },
  computed: {
    ...mapState(['common', 'user']),
    isDesign(){
      let id = this.orderDetail.servCataId;
      if(['4010110'].includes(id)&&this.orderDetail.servOrderRpd.enclosure||['4010120'].includes(id)){
        return true;
      }else{
        return false;
      }
    }
  },
  methods: {
    // 设计师未接单隐藏信息
    hideInfo() {
      let status = this.orderDetail.orderStatus
      if ((status == '10' && this.user.userType == '20') || status == '99' ||
        status == '90' || status == '91' || status == '92' || status == '98') {
        var str1 = '';
        var str2 = '';
        var str3 = '';
        var str4 = '';
        for (var i = 0; i < this.orderDetail.demContact.length - 2; i++) {
          str1 += '*'
        }
        for (var i = 0; i < this.orderDetail.demPatient.length - 2; i++) {
          str2 += '*'
        }
        str3 = this.orderDetail.demContact.slice(0, 1) + str1 + this.orderDetail.demContact.slice(-1)
        str4 = this.orderDetail.demPatient.slice(0, 1) + str2 + this.orderDetail.demPatient.slice(-1)
        this.orderDetail.demPhone = this.orderDetail.demPhone.slice(0, 3) + '****' + this.orderDetail.demPhone.slice(-4)
        this.orderDetail.demContact = this.orderDetail.demContact.length == 2 ? this.orderDetail.demContact.slice(0, 1) + '*' : str3;
        this.orderDetail.demPatient = this.orderDetail.demPatient.length == 2 ? this.orderDetail.demPatient.slice(0, 1) + '*' : str4;
      }
    },
    // 显示对应的设计类型
    showStr(accessories){
      let map = [
        {
          value: '00',
          label: '个性托盘设计'
        },
        {
          value: '01',
          label: '暂基托设计'
        },
        {
          value: '02',
          label: '总义齿设计'
        }
      ]
      for (let i = 0; i < map.length; i++) {
        if(map[i].value==accessories){
          return map[i].label;
        }
      }
      return '';
    },
  },
  created() {
    this.hideInfo();
    this.orderDetail.teethList = this.orderDetail.posSingleList?this.orderDetail.posSingleList.map((item)=>parseInt(item)):[];
  },
  mounted() {
  },
  components: {
    BaseTag,
    DictTag,
    DTooth
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/mixin.scss";

.order-input-wrap {
  width: 100%;
  margin-top: 10px;
  position: relative;
}

.design-img {
  width: 33%;
  height: 630px;
  display: flex;
  flex-direction: column;
  img{
    width: 570px;
    height: 620px;
  }
}

.design-info {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
}

.input-form-wrap,
.input-form-wrap-row {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  height: 32px;
}

// 输入框
.input-form-wrap {
  width: 50%;
  padding: 7px 10px;

  .input-label {
    // flex: 1;
    width: 140px;
    margin-left: 2%;
  }
}

// 四列输入框
.input-form-wrap-row {
  width: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 7px 10px;

  .input-label {
    // flex: 1;
    width: 110px;
    margin-left: 2%;
  }
}

.input-value {
  flex: 1;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 2px 10px;
  background-color: #ECECEC;
  width: 260px;
}

.input-textarea {
  padding: 5px 10px;
}

.el-textarea.is-disabled .el-textarea__inner {
  border-color: #DCDFE6;
  color: #606266;
  cursor: not-allowed;
  font-size: 14px;
  background-color: #ECECEC;
}

.param-info::after {
  content: '(黑色为默认参数，仅供参考)';
  font-size: 12px;
  position: absolute;
  top: 18px;
  left: 80px;
}
</style>



// WEBPACK FOOTER //
// activeDetail.vue?207be6b3